import React, { Fragment, useCallback, useEffect, useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { translate } from '../Services/translation';
import { query, searchFacetChange } from '../Actions/FacetedSearch.action';
import { useStateWithCallbackLazy } from 'use-state-with-callback';

const FacetedSearchGroup = ({ group }) => {
    const [collapsedProduct, setCollapsedProduct] = useStateWithCallbackLazy(false);
    const showLessItemCount = useRef(5);
    const productListRef = useRef(null);
    const showLess = useRef(null);
    const showMore = useRef(null);
    const showLessBottom = useRef(null);
    const showMoreBottom = useRef(null);
    const listTop = useRef(null);
    const firstRender = useRef(true);


    const [collapsedRecipe, setCollapsedRecipe] = useStateWithCallbackLazy(false);
    const recipeListRef = useRef(null);
    const recipeListTop = useRef(null);
    const recipeShowLess = useRef(null);
    const recipeShowMore = useRef(null);
    const recipeShowLessBottom = useRef(null);
    const recipeShowMoreBottom = useRef(null);

    const sortByName = (a, b) => {
        if ( a.id < b.id ){
            return -1;
        }
        if ( a.id > b.id ){
            return 1;
        }
        return 0;
    }

    const toggleShowMoreRecipe = useCallback(() => {
        setCollapsedRecipe(
            (prevState) => !prevState,
            (collapsedRecipe) => {
                recipeListRef.current.style.height = `${
                    (collapsedRecipe
                        ? recipeShowLessBottom.current
                        : recipeShowMoreBottom.current) - listTop.current
                }px`;
            }
        );
    }, [setCollapsedRecipe]);

    const toggleShowMoreProducts = useCallback(() => {
        setCollapsedProduct(
            (prevState) => !prevState,
            (collapsedProduct) => {
                productListRef.current.style.height = `${
                    (collapsedProduct
                        ? showLessBottom.current
                        : showMoreBottom.current) - listTop.current
                }px`;
            }
        );
    }, [setCollapsedProduct]);

    useEffect(() => {
        // Make sure it is executed only once.
        // firstRender is used to prevent eslint warning when having empty dependencies array
        if (!firstRender.current) {
            return;
        }
        firstRender.current = false;

        const {
            height: listHeightRecipe,
            top: listPosTopRecipe,
        } = recipeListRef.current.getBoundingClientRect();

        const {
            height: listHeight,
            top: listPosTop,
        } = productListRef.current.getBoundingClientRect();

        listTop.current = listPosTop;
        recipeListTop.current = listPosTopRecipe;

        showLessBottom.current = showLess.current
            ? showLess.current.getBoundingClientRect().bottom
            : null;
        if(showMore.current) {
            showMoreBottom.current = showMore.current.getBoundingClientRect().bottom;
        }

        recipeShowLessBottom.current = recipeShowLess.current
            ? recipeShowLess.current.getBoundingClientRect().bottom
            : null;

        const visible = listHeight !== 0;
        const tooManyItems = group.options.length > showLessItemCount.current;

        visible && tooManyItems && toggleShowMoreRecipe();
        visible && tooManyItems && toggleShowMoreProducts();
    }, [group, toggleShowMoreRecipe, toggleShowMoreProducts]);


    let recipeList = group.options.filter( element => element.isRecipe )
    let productList = group.options.filter( element => !element.isRecipe )

    if (group.id === 'Brand') {
        productList.sort(sortByName);
    }

    return (
        <Fragment>
            <div className={"faceted-search__group-wrapper" + (group.isSpecialDiet ? " is-special-diet" : "")} role="group" >
                <div
                    className="faceted-search__group-header"
                    role="group"
                    aria-label={group.label}
                >
                    {group.label}
                </div>
                <ul className="faceted-search__group" ref={productListRef}>
                    {productList.map((item, itemIndex, array) => (
                        <li
                            key={`${item.label}-${itemIndex}`}
                            className="faceted-search__item"
                            ref={(elem) => {
                                if (
                                    itemIndex ===
                                    showLessItemCount.current - 1
                                ) {
                                    showLess.current = elem;
                                }
                                if (itemIndex === array.length - 1) {
                                    showMore.current = elem;
                                }
                            }}
                        >
                            <FacetedFilterCheckbox item={item} group={group} />
                        </li>
                    ))}
                </ul>
                {productList.length > showLessItemCount.current && (
                    <span
                        className="faceted-search__show-more"
                        onClick={() => toggleShowMoreProducts()}
                    >
                        {`${
                            collapsedProduct
                                ? translate('filter.showmore')
                                : translate('filter.showless')
                        }`}
                    </span>
                )}
                {recipeList.length > 0 && (
                    <div
                        className="faceted-search__group-header"
                        role="faceted-search-item-group"
                    >
                        Recept
                    </div>
                )}
                <ul className="faceted-search__group" ref={recipeListRef}>
                    {recipeList.map((item, itemIndex, array) => (
                        <li
                            key={`${item.label}-${itemIndex}`}
                            className="faceted-search__item"
                            role="faceted-search-item"
                            ref={(elem) => {
                                if (
                                    itemIndex ===
                                    showLessItemCount.current - 1
                                ) {
                                    showLess.current = elem;
                                }
                                if (itemIndex === array.length - 1) {
                                    showMore.current = elem;
                                }
                            }}
                        >
                            <FacetedFilterCheckbox item={item} group={group} />
                        </li>
                    ))}
                </ul>
                {recipeList.length > showLessItemCount.current && (
                    <span
                        className="faceted-search__show-more"
                        onClick={() => toggleShowMoreRecipe()}
                    >
                        {`${
                            collapsedRecipe
                                ? translate('filter.showmore')
                                : translate('filter.showless')
                        }`}
                    </span>
                )}
            </div>
        </Fragment>
    )

};

const FacetedFilterCheckbox = ({ item, group }) => {
    const dispatch = useDispatch();
    const onChange = useCallback(
        (group, item) => dispatch(searchFacetChange(group, item)),
        [dispatch]
    );
    return (
        <label className="faceted-filter">
            <input
                className="faceted-filter__input"
                type="checkbox"
                onChange={(event) => onChange(group, item)}
                checked={
                    group.selectedOptions != null &&
                    group.selectedOptions.includes(item.id)
                }
            />
            <span className="faceted-filter__label">
                {item.label}
                {!isNaN(item.quantity) && item.quantity != null && (
                    <span className="faceted-filter__quantity">
                        &nbsp;({item.quantity})
                    </span>
                )}
            </span>
        </label>
    );
};

const FacetedSearch = () => {
    const dispatch = useDispatch();
    const { facetFilters, navigationTheme } = useSelector(
        (state) => state.facetedSearch
    );

    useEffect(() => {
        // listen to history events (back, forward) of window
        window.onpopstate =
            window.onpopstate ||
            ((event) => {
                dispatch(query(window.location.search.substr(1) || ''));
            });
    }, [dispatch]);

    if (!facetFilters.length) {
        return '';
    }

    return (
        navigationTheme !== 'category' &&
        facetFilters &&
        facetFilters.length > 0 && (
            <div className="faceted-search">
                {facetFilters.map((group, groupIndex) => (
                    <FacetedSearchGroup
                        key={`${group.label}-${groupIndex}`}
                        group={group}
                    />
                ))}
            </div>
        )
    );
};

export default FacetedSearch;
